<template>
  <div class="photo-browser__search-bar" v-if="visible">
    <CRow class="align-items-center justify-content-between">
      <CCol col="auto">
        <div class="d-flex align-items-center" v-if="numSelected > 0">
          <CButtonClose class="list-item-closer mr-2" @click="$emit('resetSelected')">
            <CIcon name="cipClose" size="custom-size" width="15"/>
          </CButtonClose>
          <span><b>{{ numSelected }}</b> <translate>photos selected</translate></span>
          <!--<CLink @click="filterForSelected" color="primary"><b>View</b></CLink>-->
        </div>
      </CCol>
      <CCol col="auto">
        <div class="d-flex align-items-center nav-res" v-if="searchResult">
          <CButton color="secondary" @click="prevSearchResult" class="ml-2 btn-circle"
                   :disabled="!searchResult.hasPrev">
            <CIcon name="cipChevronLeft" size="lg"/>
          </CButton>

          <span class="ml-2">{{ searchResult.actual }} / {{ searchResult.total }}</span>
          <CButton color="secondary" @click="nextSearchResult" class="ml-2 btn-circle"
                   :disabled="!searchResult.hasNext">
            <CIcon name="cipChevronLeft" size="custom-size" style="transform: rotate(180deg);"/>
          </CButton>
        </div>
      </CCol>
      <CCol col="auto">
        <div class="d-flex align-items-center" v-if="numSelected > 0">
          <PDropDown
              color="secondary"
              :items="actions"
              v-if="actions.length > 0"
              :button-if-single-item="true"
              :reset-on-select="true"
              :empty-label="$pgettext('uploader', 'Action')"
              @change="$emit('action', $event)"
          />
          <CButton color="primary" size="sm" @click="$emit('download')" class="ml-2">
            <translate>Download</translate>
            <CIcon size="custom" width="16" name="cipDownload03" class="ml-1"/>
          </CButton>
        </div>

      </CCol>
    </CRow>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PDropDown from "@/domain/core/components/PDropDown.vue";

export default {
  name: "BottomBar",
  components: {PDropDown},
  emits: ['resetSelected', 'filter', 'download', 'addTags', 'setGallery', 'action'],
  props: {
    selected: {
      type: Object,
      required: true
    },
    actions: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('photoSearch', [
      'searchResult',
    ]),
    numSelected() {
      if (!this.selected) return 0
      return Object.keys(this.selected).length
    },
    visible() {
      return this.numSelected > 0 || this.searchResult
    },
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions('photoSearch', [
      'nextSearchResult',
      'prevSearchResult',
    ]),
    filterForSelected() {
      const ids = Object.keys(this.selected)
      this.$emit('filter', {selected: ids})
    },
  }
}
</script>